var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11086_93629)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.9375 5.75H10.5V4C10.5 2.06975 8.93025 0.5 7 0.5C5.06975 0.5 3.5 2.06975 3.5 4V5.75H3.0625C2.33917 5.75 1.75 6.33858 1.75 7.0625V13.1875C1.75 13.9114 2.33917 14.5 3.0625 14.5H10.9375C11.6608 14.5 12.25 13.9114 12.25 13.1875V7.0625C12.25 6.33858 11.6608 5.75 10.9375 5.75ZM4.66667 4C4.66667 2.71317 5.71317 1.66667 7 1.66667C8.28683 1.66667 9.33333 2.71317 9.33333 4V5.75H4.66667V4ZM7.58333 10.2545V11.5833C7.58333 11.9053 7.32258 12.1667 7 12.1667C6.67742 12.1667 6.41667 11.9053 6.41667 11.5833V10.2545C6.06958 10.0521 5.83333 9.67992 5.83333 9.25C5.83333 8.60658 6.35658 8.08333 7 8.08333C7.64342 8.08333 8.16667 8.60658 8.16667 9.25C8.16667 9.67992 7.93042 10.0521 7.58333 10.2545Z",
    fill: "#404349"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11086_93629"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.174c2b8a0f25177e6d6a23b15b53d0e0.svg";
export { ForwardRef as ReactComponent };